import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Axios from "axios";

import InfoIcon from "@material-ui/icons/Info";

import { useStyles } from "./ViewFeeGroup.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import AddFeeGroup from "../AddFeeGroup/AddFeeGroup";
import FeeGroupBody from "../FeeGroupBody/FeeGroupBody";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewFeeGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      column: [
        { name: "S.N." },
        { name: "Class" },
        { name: "Faculty" },
        { name: "Group" },
        { name: "Fee Heads" },
        { name: "Actions" },
      ],
      feeGroups: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getFeeGroup();
  }

  getFeeGroup = async () => {
    try {
      const response = await Axios.get(`${url}/api/fee-groups`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.feesGroups.length !== 0) {
        this.setState({
          feeGroups: response.data.feesGroups,
          isEmpty: false,
        });
      } else {
        this.setState({
          feeGroups: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getFeeGroup();
      }
    }
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Fee Grouping" refreshUrl={this.props.match.url} />

          {this.state.feeGroups.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />
                <TableBody>
                  <AddFeeGroup getFeeGroup={this.getFeeGroup} />
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={6}
                      style={{ textAlign: "center" }}
                    >
                      After adding the class please click <InfoIcon /> to add
                      fee heads.
                    </TableCell>
                  </TableRow>
                </TableBody>

                <TableBody>
                  {this.state.feeGroups.map((fee, index) => (
                    <FeeGroupBody
                      key={index}
                      index={index}
                      data={fee}
                      getFeeGroup={this.getFeeGroup}
                    />
                  ))}
                </TableBody>

                <CustomTableFooter
                  count={this.state.feeGroups.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <div>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />
                  <TableBody>
                    <AddFeeGroup getFeeGroup={this.getFeeGroup} />
                    <TableRow>
                      <TableCell align="center">
                        After adding the class please click <InfoIcon /> to add
                        fee heads.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <CustomEmptyMessage />
            </div>
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ViewFeeGroup));
